import { render } from "./footer.vue?vue&type=template&id=314fc14b"
const script = {}

import exportComponent from "C:\\work\\smile\\pricing_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__